import { useEffect, useState } from "react";
import BookService from "../../services/BookService";
import Pagination from "../CommonComponents/Pagination";
import BookCard from "./BookCard";
import BookDetail from "./BookDetail";
import Spinner from "../CommonComponents/Spinner";

const pageSize = 7;

function BooksGrid({ user }) {
  const [books, setBooks] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedBookId, setSelectedBookId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const loadBooks = async () => {
      try {
        const res = await BookService.getBooks(currentPage, pageSize);
        setBooks(res.content);
        setTotalPages(Math.ceil(res.totalElements / pageSize));
      } catch (error) {
        console.error("Greška pri dohvaćanju knjiga:", error);
      } finally {
        setLoading(false);
      }
    };
    loadBooks();
  }, [currentPage]);

  if (loading) {
    return <Spinner />;
  }

  if (selectedBookId) {
    return (
      <BookDetail
        bookId={selectedBookId}
        user={user}
        onBack={() => setSelectedBookId(null)}
      />
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "16px",
          padding: "16px",
        }}
      >
        {books.map((book) => (
          <BookCard
            key={book.id}
            book={book}
            user={user}
            onClick={() => setSelectedBookId(book.id)}
          />
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={(page) => {
          setCurrentPage(page);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      />
    </div>
  );
}

export default BooksGrid;
